export default "__VITE_ASSET__C2H8c9$x__"